import { Tag } from '@zillow/constellation-10';

import { css, cx } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { TagPropsInterface } from '@zillow/constellation-10';

export const LoadingTag = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  className,
  icon,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth: string;
} & TagPropsInterface) => (
  <Tag
    data-loading={isLoading || null}
    // oxlint-disable-next-line constellation/no-classname-css-on-components -- must merge the computed shimmer css with the consumer's own className, which the css prop can't accept
    className={cx(css(shimmerStyles, cssProp), className)}
    style={isLoading ? { width: loadingWidth, ...styleProp } : { ...styleProp }}
    icon={isLoading ? null : icon}
    {...rest}
  >
    {isLoading ? <>&nbsp;</> : children}
  </Tag>
);
